import { Sidebar, SidebarProps, Position } from '@optimus-web/core';
import {
    isCurrentEnterprisePortfolio,
    isCurrentEnterpriseApplicationProvider,
} from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { hasCurrentEnterpriseSsoAccessOnly } from '@mews-commander/legacy-entities/src/selectors/session/enterpriseProductSubscriptions';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import {
    AccessControlMenu,
    ApplicationProviderMenu,
    PlatformAdminAndServiceProviderMenu,
    PortfolioMenu,
} from './Menus';
import { SidebarContentWrapper } from './style';
import { isAppSidebarOpened } from './reducer';
import { closeAppSidebar } from './actions';

type DefaultProps = Pick<SidebarProps, 'absolute' | 'closeOnBackdropClick' | 'modal' | 'position' | 'width'>;
type ExternalSidebarProps = Omit<SidebarProps, keyof DefaultProps | 'onClose' | 'opened'>;

const sidebarProps: DefaultProps = {
    absolute: true,
    closeOnBackdropClick: true,
    modal: false,
    position: Position.Left,
    width: '270px',
};

export interface AppSidebarProps extends ExternalSidebarProps {
    closeSidebar: () => void;
    isApplicationProvider: boolean;
    isPortfolio: boolean;
}

export const AppSidebar = (props: ExternalSidebarProps) => {
    const dispatch = useCommanderThunkDispatch();
    const closeSidebar = () => dispatch(closeAppSidebar());

    const hasSsoAccessOnly = useCommanderSelector(hasCurrentEnterpriseSsoAccessOnly);
    const isApplicationProvider = useCommanderSelector(isCurrentEnterpriseApplicationProvider) as boolean;
    const isPortfolio = useCommanderSelector(isCurrentEnterprisePortfolio);
    const opened = useCommanderSelector(isAppSidebarOpened);
    let menu = <PlatformAdminAndServiceProviderMenu />;

    if (isPortfolio) {
        menu = hasSsoAccessOnly ? <AccessControlMenu /> : <PortfolioMenu />;
    } else if (isApplicationProvider) {
        menu = <ApplicationProviderMenu />;
    }

    return (
        <Sidebar opened={opened} onClose={closeSidebar} {...sidebarProps} {...props}>
            <SidebarContentWrapper data-test-appsidebar>{menu}</SidebarContentWrapper>
        </Sidebar>
    );
};
